import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = [ "content", "seeMoreButton", "seeMoreButtonText" ];

  static values = {
    initialMaxHeight: String,
    seeMoreText: String,
    seeLessText: String
  }

  connect() {
    this.expanded = false;
    this.checkIfClampingNeeded();
  }

  toggle() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.open(this.element);
    } else {
      this.collapse(this.element);
    }
  }

  collapse(element) {
    element.classList.add("clamped");
    this.seeMoreButtonTextTarget.textContent = this.seeMoreTextValue;
  }

  open(element) {
    element.classList.remove("clamped");
    this.seeMoreButtonTextTarget.textContent = this.seeLessTextValue;
  }

  checkIfClampingNeeded() {
    const button = this.seeMoreButtonTarget;

    const needsClamping = this.initialMaxHeightValue < this.element.clientHeight;

    if (needsClamping) {
      this.contentTarget.classList.add("clamped");
      this.element.classList.add("clamped");
      button.style.display = "flex";
    } else {
      this.contentTarget.classList.remove("clamped");
      this.element.classList.remove("clamped");
      button.style.display = "none";
      this.contentTarget.dataset.bottom = true;
    }
  }
}
